import { render, staticRenderFns } from "./AddNewTemplate.vue?vue&type=template&id=48cf3178&scoped=true"
import script from "./AddNewTemplate.vue?vue&type=script&lang=js"
export * from "./AddNewTemplate.vue?vue&type=script&lang=js"
import style0 from "./AddNewTemplate.vue?vue&type=style&index=0&id=48cf3178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cf3178",
  null
  
)

export default component.exports